import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { axiosPostInstanceUW } from "shared/axiosInstance";
import { uwQuestionsApi } from "shared/apiEndpoints";

const UWQuestionsPage = () => {
  const [searchParams] = useSearchParams();
  const [uwQuestionsData, setUWQuestionsData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  //const segmentCd = "SC";

  const searchParam = {
    lobAbbr: searchParams.get("lobAbbr") ?? null,
    riskState: searchParams.get("riskState") ?? null,
    segment: searchParams.get("segment") ?? null,
    classCd: searchParams.get("classCd") ?? null,
    classDesc: searchParams.get("classDesc") ?? null,
    classDescCd: searchParams.get("classDescCd") ?? null,
  };

  const getUWQuestionsPayload = {
    lobAbbr: searchParam.lobAbbr,
    riskState: searchParam.riskState,
    segment: searchParam.segment,
    classCd: searchParam.classCd,
    classDesc: searchParam.classDesc,
    classDescCd: searchParam.classDescCd,
  };
console.log("lobCd", searchParam.lobAbbr);
  /* const getUWQuestionsPayload = {
    "lobAbbr": "SPEC",
    "riskState": "CA",
    "segment": "SC",
    "classCd": "40801",
    "classDescCd": "10",
    "classDesc": "Cellular Phone Sales, Installation",
    "optionalCoverageAbbr": null,
    "optionalCoverageName": null
  }; */

  /* const getUWQuestionsPayload = {
    lobAbbr: "SPEC",
    riskState: "CA",
    segment: "SC",
    classCd: "40801",
    classDescCd: "10",
    classDesc: "Cellular Phone Sales, Installation",
    optionalCoverageAbbr: null,
    optionalCoverageName: null
  }; */

  useEffect(() => {
    //setLoading(true);
    axiosPostInstanceUW()
      .post(uwQuestionsApi, getUWQuestionsPayload)
      .then((res) => {
        setUWQuestionsData(res.data);
       // setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching UW questions:", error);
        //setError(error);
        //setLoading(false);
      });
  }, []);

  //if (loading) return <div>Loading underwriting questions...</div>;
  //if (error) return <div>Error loading data. Please try again later.</div>;
console.log("uwQuestionsData", uwQuestionsData);
  return (
    <div >
        {/* Backend returns safe HTML string */}
        <div dangerouslySetInnerHTML={{ __html: uwQuestionsData }} />
    </div>
  );
};

export default UWQuestionsPage;
